import { useParams } from 'react-router-dom'

import { SceneContainer } from '../components/scene/SceneContainer'
import { RepeatingEvents } from '../components/repeating-events/RepeatingEvents'

function ManageCalendarScreen() {
  const { workspaceId } = useParams()

  if (!workspaceId) {
    return <div>No business selected</div>
  }

  return (
    <SceneContainer
      title="Manage calendar"
      description="Manage your events and deadlines"
    >
      <h2 className="text-xl font-medium">Recurring events</h2>
      <RepeatingEvents />
    </SceneContainer>
  )
}

export default ManageCalendarScreen
